import { render } from "./PortfolioMenu.vue?vue&type=template&id=8dd1cf8c"
import script from "./PortfolioMenu.vue?vue&type=script&lang=js"
export * from "./PortfolioMenu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__